interface ShowMoreButtonProps {
  showAll: boolean
  onClick: () => void
  className?: string
  canLoadMore?: boolean
}

export default function ShowMoreButton({
  showAll,
  onClick,
  className = '',
  canLoadMore = false,
}: ShowMoreButtonProps) {
  // Determine button text based on state
  let buttonText = 'Show More'
  if (showAll) {
    buttonText = canLoadMore ? 'Load More' : 'Show Less'
  }

  return (
    <div className="mt-8 flex justify-center">
      <button
        className={`font-space-grotesk rounded-2xl border border-gray-200 bg-white px-6 py-3 text-sm font-medium text-gray-900 shadow-sm transition-colors hover:bg-gray-50 ${className}`}
        onClick={onClick}
      >
        {buttonText}
      </button>
    </div>
  )
}
